const SpreadsheetIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 1.33337V2.66671H13.3377C13.7035 2.66671 14 2.96334 14 3.32897V14.0044C14 14.3702 13.7034 14.6667 13.3377 14.6667H2.66227C2.29651 14.6667 2 14.3701 2 14.0044V3.32897C2 2.96321 2.29663 2.66671 2.66227 2.66671H4.66667V1.33337H11.3333ZM4.66667 4.00004H3.33333V13.3334H12.6667V4.00004H11.3333V5.33337H4.66667V4.00004ZM6 10.6667V12H4.66667V10.6667H6ZM6 8.66671V10H4.66667V8.66671H6ZM6 6.66671V8.00004H4.66667V6.66671H6ZM10 2.66671H6V4.00004H10V2.66671Z"
      fill="currentColor"
    />
  </svg>
);

export default SpreadsheetIcon;
